export const MOBILE_SCREEN_CUTOFF = 469;

export const TABLET_SCREEN_CUTOFF = 768;

const FUND_LOCALSTORAGE_VERISION = "v3";

export const FUND_STORAGE_KEYS = {
  ColumnVisibility: `funds-table-column-visibility_${FUND_LOCALSTORAGE_VERISION}`,
  ColumnOrder: `funds-table-column-order_${FUND_LOCALSTORAGE_VERISION}`,
  FilterVisibility: `funds-filter-visibility_${FUND_LOCALSTORAGE_VERISION}`,
  FilterOrder: `funds-filter-order_${FUND_LOCALSTORAGE_VERISION}`,
  Filters: "fund-filters",
  Sort: "funds-sort",
  Search: "funds-search",
  Pagination: "funds-pagination",
};

const CLIENT_LOCALSTORAGE_VERSION = "v2";

export const CLIENT_STORAGE_KEYS = {
  ColumnVisibility: `clients-table-column-visibility_${CLIENT_LOCALSTORAGE_VERSION}`,
  ColumnOrder: `clients-table-column-order_${CLIENT_LOCALSTORAGE_VERSION}`,
  Search: `clients-table-search`,
  Filters: `clients-table-filters`,
  Pagination: `clients-table-pagination`,
};

const FAMILY_LOCALSTORAGE_VERSION = "v1";

export const FAMILY_STORAGE_KEYS = {
  ColumnVisibility: `families-table-column-visibility_${FAMILY_LOCALSTORAGE_VERSION}`,
  ColumnOrder: `families-table-column-order_${FAMILY_LOCALSTORAGE_VERSION}`,
  Search: `families-table-search`,
  Filters: `families-table-filters`,
  Pagination: `families-table-pagination`,
};

const FUND_BASKET_LOCALSTORAGE_VERSION = "v1";

export const FUND_BASKET_STORAGE_KEYS = {
  ColumnVisibility: `funds-basket-table-column-visibility_${FUND_BASKET_LOCALSTORAGE_VERSION}`,
  ColumnOrder: `funds-basket-table-column-order_${FUND_BASKET_LOCALSTORAGE_VERSION}`,
};
